<div *ngFor="let subType of product.subTypes; let st = index; let last = last;">

        <div class="row mb-3 d-flex align-items-center" *ngIf="subType.finishesTop.length">
            <div class="col-12 col-lg-4">
                <label class="app__label">Finish - Top</label>
            </div>
            <div class="col-12 col-lg-8">
                <ng-select
                    [(ngModel)]="product.finishTop"
                    [clearable]="false"
                    [searchable]="false"
                    class="dark"
                    [placeholder]="'Please select'">
                    <ng-option [value]="undefined">None</ng-option>
                    <ng-option *ngFor="let f of subType.finishesTop" [value]="f">{{ f.name }}</ng-option>
                </ng-select>
            </div>
        </div>


    <div class="row mb-3 d-flex align-items-center" *ngIf="subType.finishesEdge.length">
        <div class="col-12 col-lg-4">
            <label class="app__label">Finish - Edge</label>
        </div>
        <div class="col-12 col-lg-8">
            <ng-select
                [(ngModel)]="product.finishEdge"
                [clearable]="false"
                [searchable]="false"
                class="dark"
                [placeholder]="'Please select'">
                <ng-option [value]="undefined">None</ng-option>
                <ng-option *ngFor="let f of subType.finishesEdge" [value]="f">{{ f.name }}</ng-option>
            </ng-select>
        </div>
    </div>


    <!--- bottom finish without edges --->
    <div
         *ngIf="subType.finishesBottom.length && (product.type.id === 'paving' || product.type.id === 'piercaps' || product.type.id === 'coping')">


         <div
            class="row d-flex align-items-center"
            [ngClass]="{'mb-3' : !last, 'mb-4': last}"
            *ngIf="subType.finishesBottom.length">
            <div class="col-12 col-lg-4">
                <label class="app__label">Finish - Underside</label>
            </div>
            <div class="col-12 col-lg-8">
                <ng-select
                    [(ngModel)]="product.finishBottom"
                    [clearable]="false"
                    [searchable]="false"
                    class="dark"
                    [placeholder]="'Please select'">
                    <ng-option [value]="undefined">None</ng-option>
                    <ng-option *ngFor="let f of subType.finishesBottom" [value]="f">{{ f.name }}</ng-option>
                </ng-select>
            </div>
        </div>


    </div>

</div>

